<script setup lang="ts">
import type { PressThumbFragment } from '#graphql-operations'

// const section = ['newsCategory']
// const filtersCategory = await fetchArchiveFilters(section)

const {
  // filters,
  count,
  entries,
  status,
  error,
  isFetchingNextPage,
  fetchNextPage,
  hasNextPage,
} = await useArchive<PressThumbFragment>({
  section: ['press'],
  queryKey: 'press',
  orderBy: 'date desc',
  // filtersCategory,
  // filtersSection: section,
  // filtersQueryParam: 'category',
})

// const hasSelection = computed(() => filters.value.length > 0)
</script>

<template>
  <section class="archivePress mb-25 mt-10 lg:my-15 lg:mb-60">
    <!-- <ArchiveFilters
      v-model="filters"
      :filters-list="filtersCategory"
    /> -->
    <div class="container">
      <template v-if="status === 'error' || error">
        {{ $t('an_error_occurred_while_retrieving_entry', { label: $t('press', 2) }) }}
      </template>
      <div v-else-if="status === 'success'" class="layout-grid">
        <ul v-if="count" class="gap-4 gap-y-8 grid col-span-full grid-cols-2 lg:gap-x-0 lg:gap-y-16 lg:col-span-8 lg:col-start-3 lg:grid-cols-8">
          <li
            v-for="data, i in entries"
            :key="data!.id"
            class="lg:col-span-2 lg:col-start-$start"
            :style="{ '--start': (i % 3) * 3 + 1 }"
          >
            <CardPress :data />
          </li>
        </ul>
        <Text v-else as="div" class="typo-sans-1 text-center uppercase" :text="$t('there_are_no_entry_to_show', { label: $t('press', 2) })" />
      </div>
      <ul v-else-if="status === 'pending'" class="layout-grid">
        <li v-for="index in 6" :key="index" class="col-span-full lg:col-span-4">
          <Skeleton :index :aspect="0.8" />
        </li>
      </ul>
    </div>
    <ArchivePagination
      v-if="hasNextPage"
      :count
      :is-fetching-next-page
      :current-count="entries?.length"
      label="press"
      @fetch-next-page="fetchNextPage"
    />
  </section>
</template>
